import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from '../store';

const initialState = {
  constants: {
    CustomerStructure: [],
    ShopArea: [],
    ShopLayout: [],
    ShopLocation: [],
    ShopMaxPrice: [],
    ShopRanking: [],
    ShopSeasons: [],
    ShopStructureBrandLine: [],
    ShopStructureBrandName: [],
    ShopStructureLacosteLine: [],
    ShopStructureColmarLine: [],
    ShopStructureCategory: [],
    ShopStructureGender: [],
    ShopSurface: [],
    ShopWindows: [],
    ShopModel: [],
    ShopType: [],
    ShopWholesaleFurniture: [],
    ShopTypeDescription: [],
  },
  seasons: [],
  statuses: [],
  zones: [],
  priceList: [],
  userTypes: [],
};

export const constantsSlice = createSlice({
  name: 'constants',
  initialState,
  reducers: {
    setConstants(state, action) {
      state.constants = action.payload;
    },
    /** Populates only `constants.CustomerStructure` — fed from the
     * customer-mapper structure-types endpoint (see customers.service.ts's
     * `getStructureTypes`), not the legacy bulk `/v1/customers/constants`
     * endpoint that `setConstants` above was designed for. */
    setCustomerStructureTypes(state, action) {
      state.constants.CustomerStructure = action.payload;
    },
    /** Merges (not replaces) the Shop "analysis" dropdown lists fed from the
     * customer-mapper shop-constants endpoint (see customers.service.ts's
     * `getShopConstants`) into the existing `constants` object — a plain
     * `state.constants = action.payload` (like `setConstants` above) would
     * wipe out `CustomerStructure`/any other already-populated key, since
     * this payload only ever contains the Shop* keys and these two fetches
     * race on the page's mount effect with no guaranteed order. */
    setShopConstants(state, action) {
      state.constants = { ...state.constants, ...action.payload };
    },
    setSeasons(state, action) {
      state.seasons = action.payload;
    },
    setStatues(state, action) {
      state.statuses = action.payload;
    },
    setZones(state, action) {
      state.zones = action.payload;
    },
    setPriceList(state, action) {
      state.priceList = action.payload;
    },
    setUserTypes(state, action) {
      state.userTypes = action.payload;
    },
  },
});

export const getState = (rootState: RootState) => rootState.constants;

export const {
  setConstants,
  setCustomerStructureTypes,
  setShopConstants,
  setSeasons,
  setStatues,
  setZones,
  setPriceList,
  setUserTypes,
} = constantsSlice.actions;
